// extracted by mini-css-extract-plugin
export default {"errorAlert":"style_errorAlert__fohT3"};